module.exports = "/images/bg-footer.jpg?3ef9148094a3b440149b0b09b5c31827";